import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import RoutePath from '../../constants/route-paths'
import Theming from '../../constants/theming'

class NotFoundPage extends Component {
    render() {
        return (
            <div className="py-5" style={{ backgroundColor: Theming.backgroundColourLight}}>
                <div className="text-center py-5 px-4" style={{ color: Theming.textColourDark}}>
                    <div className="py-5">
                        <h1 className="card-title h1-responsive pt-3 font-bold py-3"><strong>404</strong></h1>
                        <h4 className="mx-5 mb-5">The Page you are looking for doesn't exist</h4>
                        <Link className="btn btn-md" to={RoutePath.home} style={{ color: Theming.textColourDark, borderColor: Theming.textColourDark}}><i className="fas fa-home"></i> Return Home</Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default NotFoundPage